import React, { useEffect } from 'react'
import { Tabs } from 'antd'
import { useParams } from 'react-router-dom'

import AppLayout from '../../../components/layout/layout'
import Loader from 'helper/Loader'
import { useGetExternalEvent } from 'api/External/External'
import ProfileHeaderExternal from './ProfileHeaderExternal'
import ExternalDetails from './Tabs/Details'

const { TabPane } = Tabs

const ExternalDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const {
    data: event,
    isLoading,
    isFetching,
    refetch,
    isError,
  } = useGetExternalEvent(id as string)

  useEffect(() => {
    if (id) {
      refetch()
    }
  }, [id, refetch])

  if (isLoading || isFetching) {
    return <Loader />
  }

  if (isError) {
    return (
      <AppLayout>
        <div className="container bg-grey">
          <div className="org-profile-header pt-30">
            <h1>Something went wrong</h1>
          </div>
        </div>
      </AppLayout>
    )
  }

  return (
    <AppLayout>
      <div className="container bg-grey">
        <div className="org-profile-header pt-30">
          <ProfileHeaderExternal event={event} />
        </div>
        <Tabs defaultActiveKey="1" className="bg-white profile-tabs">
          <TabPane tab="Details" key="1">
            <ExternalDetails event={event} />
          </TabPane>
        </Tabs>
      </div>
    </AppLayout>
  )
}

export default ExternalDetail
